import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux'; // ✅ Added missing import
import { FaTimesCircle, FaHome, FaRedo, FaHeadset } from 'react-icons/fa';
import { getColors } from '../../styles/colors';

const OrderFailed = () => {
  const theme = useSelector((state) => state.theme.mode);
  const isDark = theme === 'dark';
  const colors = getColors(isDark);

  return (
    <motion.div 
      className="py-8 max-w-2xl mx-auto px-4"
      style={{ backgroundColor: colors.background }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div 
        className="rounded-2xl p-8 text-center"
        style={{ 
          backgroundColor: colors.card,
          border: `1px solid ${colors.border}`
        }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
        >
          <div className="w-24 h-24 rounded-full bg-red-100 mx-auto flex items-center justify-center">
            <FaTimesCircle className="text-6xl text-red-500" />
          </div>
        </motion.div>
        
        <h1 className="text-3xl font-bold text-red-600 mt-4">❌ Payment Failed</h1>
        <p className="text-lg" style={{ color: colors.textSecondary }}>
          Something went wrong with your payment
        </p>
        
        <div 
          className="rounded-xl p-4 text-left mt-6"
          style={{ 
            backgroundColor: colors.inputBackground,
            border: `1px solid ${colors.border}`
          }}
        >
          <p className="text-sm" style={{ color: colors.textSecondary }}>
            <span className="font-semibold" style={{ color: colors.danger }}>Error:</span> 
            Transaction declined. Please try again or use a different payment method.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-6">
          <Link to="/checkout" className="flex-1">
            <button 
              className="w-full py-3 rounded-full font-semibold flex items-center justify-center gap-2 hover:scale-105 transition-transform"
              style={{ backgroundColor: colors.primary, color: '#FFFFFF' }}
            >
              <FaRedo /> Retry Payment
            </button>
          </Link>
          <Link to="/" className="flex-1">
            <button 
              className="w-full py-3 rounded-full font-semibold flex items-center justify-center gap-2 hover:scale-105 transition-transform"
              style={{ 
                backgroundColor: colors.border,
                color: colors.text
              }}
            >
              <FaHome /> Back to Home
            </button>
          </Link>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-3">
          <button 
            className="w-full py-3 rounded-full font-semibold flex items-center justify-center gap-2 hover:scale-105 transition-transform"
            style={{ 
              backgroundColor: colors.border,
              color: colors.text
            }}
          >
            <FaHeadset /> Contact Support
          </button>
        </div>

        <div className="mt-6 text-sm" style={{ color: colors.textSecondary }}>
          <p>💡 Check your card details and try again</p>
          <p>💡 Contact your bank for more information</p>
          <p>💡 Try a different payment method</p>
        </div>
      </div>
    </motion.div>
  );
};

export default OrderFailed;